import { render, staticRenderFns } from "./loan-offers.vue?vue&type=template&id=0a90245b&scoped=true"
import script from "./loan-offers.vue?vue&type=script&lang=js"
export * from "./loan-offers.vue?vue&type=script&lang=js"
import style0 from "./loan-offers.vue?vue&type=style&index=0&id=0a90245b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90245b",
  null
  
)

export default component.exports